import RuejaiClubSalePackageCreatePage from "./pages/RuejaiClubSalePackageCreatePage";
import RuejaiClubSalePackageListPage from "./pages/RuejaiClubSalePackageListPage";
import RuejaiClubSalePackageDetailPage from "./pages/RuejaiClubSalePackageDetailPage";

export const ruejaiClubSalePackageRoutes = (prefix = "sale-packages") => [
  {
    name: "RuejaiClubSalePackageCreatePage",
    path: `${prefix}/create`,
    component: RuejaiClubSalePackageCreatePage
  },
  {
    name: "RuejaiClubSalePackageDetailPage",
    path: `${prefix}/:id`,
    component: RuejaiClubSalePackageDetailPage
  },
  {
    name: "RuejaiClubSalePackageListPage",
    path: prefix,
    component: RuejaiClubSalePackageListPage
  }
];
